import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { Emoji } from "emoji-picker-react";
import { PlannerContext } from "../../../context/planner/PlannerContext";
import { calculateBlockHeight } from "../../../helpers/planner/calculateBlockHeight";
import { isLightColor } from "../../../helpers/colorUtils";

const ActivityBlock = ({
  block,
  isSelected = false,
  onClick,
  isPast = false,
}) => {
  const { activities, timeToMinutes } = useContext(PlannerContext);
  const { name, activityId, startTime, endTime } = block;

  // Find the activity from the user's activities
  const activity = activities.find((a) => a.id === activityId);
  const activityName = activity?.name || name || "Activity";
  const activityEmoji = activity?.emoji;
  const activityColor = activity?.color;

  const handleClick = isPast ? undefined : onClick;
  const blockHeight = calculateBlockHeight(startTime, endTime, timeToMinutes);

  // Determine if we need dark text for light backgrounds
  const textColor =
    activityColor && isLightColor(activityColor) ? "#333333" : "white";

  return (
    <Box
      className={`block activity-block ${isSelected ? "block--selected" : ""} ${isPast ? "block--past" : ""}`}
      onClick={handleClick}
      sx={{
        ...(isPast ? { cursor: "default" } : {}),
        height: `${blockHeight}px`,
        ...(activityColor && {
          backgroundColor: activityColor,
          backgroundImage: "none",
          "&:hover": {
            backgroundColor: activityColor,
            backgroundImage: "none",
            filter: "brightness(1.1)",
          },
        }),
      }}
    >
      <Box className="block_title-time-wrapper">
        <Typography
          variant="body1"
          className="block_title"
          sx={{ color: textColor }}
        >
          {activityEmoji && (
            <span
              style={{
                marginRight: 6,
                display: "inline-flex",
                verticalAlign: "middle",
              }}
            >
              <Emoji unified={activityEmoji} size={16} />
            </span>
          )}
          {activityName}
        </Typography>
        <Box className="block_time-badge">
          <Typography
            variant="caption"
            className="block_time-badge-text"
            sx={{ color: textColor }}
          >
            {startTime} — {endTime}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ActivityBlock;
